export const messages = {
  en: {
    roomCreatePayFee: {
      title: 'Room Create Fee',
      feeType: 'Fee Type',
      feeItem: 'Fee Item',
      startTime: 'Start Time',
      endTime: 'End Time',
      amount: 'Amount',
      rateCycle: 'Rate Cycle',
      rate: 'Rate',
      rateStartTime: 'Rate Start Time',
      building: 'Building',
      roomState: 'Room State',
      room: 'Room',
      selectFeeType: 'Please select fee type',
      selectFeeItem: 'Please select fee item',
      selectStartTime: 'Please select start time',
      selectEndTime: 'Please select end time',
      inputAmount: 'Please input amount',
      inputRateCycle: 'Please input rate cycle (month)',
      inputRate: 'Please input rate',
      selectRateStartTime: 'Please select rate start time',
      selectBuilding: 'Please select building',
      selectAll: 'Select All',
      noRoom: 'No Room',
      validateError: 'Validation failed',
      noRoomSelected: 'No room selected',
      occupied: 'Occupied',
      delivered: 'Delivered',
      decorated: 'Decorated',
      vacant: 'Vacant',
      rented: 'Rented',
      sold: 'Sold'
    }
  },
  zh: {
    roomCreatePayFee: {
      title: '房屋创建费用',
      feeType: '费用类型',
      feeItem: '收费项目',
      startTime: '计费起始时间',
      endTime: '计费结束时间',
      amount: '收费金额',
      rateCycle: '递增周期',
      rate: '计费递增率',
      rateStartTime: '递增开始时间',
      building: '楼栋',
      roomState: '房屋状态',
      room: '房屋',
      selectFeeType: '请选择费用类型',
      selectFeeItem: '请选择收费项目',
      selectStartTime: '请选择计费起始时间',
      selectEndTime: '请选择计费结束时间',
      inputAmount: '请输入收费金额',
      inputRateCycle: '请输入递增周期(月份)',
      inputRate: '请输入递增率',
      selectRateStartTime: '请选择递增开始时间',
      selectBuilding: '请选择楼栋',
      selectAll: '全选',
      noRoom: '没有房屋',
      validateError: '验证失败',
      noRoomSelected: '未包含房屋',
      occupied: '已入住',
      delivered: '已交房',
      decorated: '已装修',
      vacant: '未入住',
      rented: '已出租',
      sold: '已出售'
    }
  }
}